
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("caV8q", function(module, exports) {
module.exports = import("j8HgI").then(()=>parcelRequire('037wc'));

});

function $2ff905f7beff5174$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $53ecac5ed2bc32f9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $53ecac5ed2bc32f9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3d396911d7f4ee30$export$8960430cfd85939f = Math.max;
var $3d396911d7f4ee30$export$96ec731ed4dcb222 = Math.min;
var $3d396911d7f4ee30$export$2077e0241d6afd3c = Math.round;



function $6931b6dfd9ac7b79$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $1cb94b3ec438f6e4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6931b6dfd9ac7b79$export$2e2bcd8739ae039)());
}


function $2f689a5d3f7bdbac$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3d396911d7f4ee30$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3d396911d7f4ee30$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(element) ? (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $1cb94b3ec438f6e4$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $589bf04e44fe9a7c$export$2e2bcd8739ae039(node) {
    var win = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6b96f24a25be01bb$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $67accc6615d52d0f$export$2e2bcd8739ae039(node) {
    if (node === (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(node) || !(0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(node)) return (0, $589bf04e44fe9a7c$export$2e2bcd8739ae039)(node);
    else return (0, $6b96f24a25be01bb$export$2e2bcd8739ae039)(node);
}


function $ee295f51d9d77b47$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $309470d3f7110c85$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $64dc08e0ab50c788$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2f689a5d3f7bdbac$export$2e2bcd8739ae039)((0, $309470d3f7110c85$export$2e2bcd8739ae039)(element)).left + (0, $589bf04e44fe9a7c$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $178d7810eb5de6d3$export$2e2bcd8739ae039(element) {
    return (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $cc971a3188892069$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $115d491f91316dac$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3d396911d7f4ee30$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3d396911d7f4ee30$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $115d491f91316dac$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(offsetParent) && $115d491f91316dac$var$isElementScaled(offsetParent);
    var documentElement = (0, $309470d3f7110c85$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2f689a5d3f7bdbac$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $cc971a3188892069$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $67accc6615d52d0f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2f689a5d3f7bdbac$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $64dc08e0ab50c788$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $176370100cdcabc3$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2f689a5d3f7bdbac$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $7fa3ef45193968b0$export$2e2bcd8739ae039(element) {
    if ((0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $53ecac5ed2bc32f9$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $309470d3f7110c85$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $f9b0f34c07f60059$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(node) && (0, $cc971a3188892069$export$2e2bcd8739ae039)(node)) return node;
    return $f9b0f34c07f60059$export$2e2bcd8739ae039((0, $7fa3ef45193968b0$export$2e2bcd8739ae039)(node));
}





function $9ffb87717c901c22$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $f9b0f34c07f60059$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $cc971a3188892069$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($9ffb87717c901c22$export$2e2bcd8739ae039((0, $7fa3ef45193968b0$export$2e2bcd8739ae039)(target)));
}







function $0ac5b2c0ab247a09$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(element)) >= 0;
}




function $903f3a9146d69b74$var$getTrueOffsetParent(element) {
    if (!(0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $903f3a9146d69b74$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6931b6dfd9ac7b79$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6931b6dfd9ac7b79$export$2e2bcd8739ae039)());
    if (isIE && (0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $7fa3ef45193968b0$export$2e2bcd8739ae039)(element);
    if ((0, $53ecac5ed2bc32f9$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $903f3a9146d69b74$export$2e2bcd8739ae039(element) {
    var window = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(element);
    var offsetParent = $903f3a9146d69b74$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $0ac5b2c0ab247a09$export$2e2bcd8739ae039)(offsetParent) && (0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $903f3a9146d69b74$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $903f3a9146d69b74$var$getContainingBlock(element) || window;
}


var $d4fe28949b3be743$export$1e95b668f3b82d = 'top';
var $d4fe28949b3be743$export$40e543e69a8b3fbb = 'bottom';
var $d4fe28949b3be743$export$79ffe56a765070d2 = 'right';
var $d4fe28949b3be743$export$eabcd2c8791e7bf4 = 'left';
var $d4fe28949b3be743$export$dfb5619354ba860 = 'auto';
var $d4fe28949b3be743$export$aec2ce47c367b8c3 = [
    $d4fe28949b3be743$export$1e95b668f3b82d,
    $d4fe28949b3be743$export$40e543e69a8b3fbb,
    $d4fe28949b3be743$export$79ffe56a765070d2,
    $d4fe28949b3be743$export$eabcd2c8791e7bf4
];
var $d4fe28949b3be743$export$b3571188c770cc5a = 'start';
var $d4fe28949b3be743$export$bd5df0f255a350f8 = 'end';
var $d4fe28949b3be743$export$390fd549c5303b4d = 'clippingParents';
var $d4fe28949b3be743$export$d7b7311ec04a3e8f = 'viewport';
var $d4fe28949b3be743$export$ae5ab1c730825774 = 'popper';
var $d4fe28949b3be743$export$ca50aac9f3ba507f = 'reference';
var $d4fe28949b3be743$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d4fe28949b3be743$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d4fe28949b3be743$export$b3571188c770cc5a,
        placement + "-" + $d4fe28949b3be743$export$bd5df0f255a350f8
    ]);
}, []);
var $d4fe28949b3be743$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d4fe28949b3be743$export$aec2ce47c367b8c3, [
    $d4fe28949b3be743$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d4fe28949b3be743$export$b3571188c770cc5a,
        placement + "-" + $d4fe28949b3be743$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d4fe28949b3be743$export$421679a7c3d56e = 'beforeRead';
var $d4fe28949b3be743$export$aafa59e2e03f2942 = 'read';
var $d4fe28949b3be743$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d4fe28949b3be743$export$c65e99957a05207c = 'beforeMain';
var $d4fe28949b3be743$export$f22da7240b7add18 = 'main';
var $d4fe28949b3be743$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d4fe28949b3be743$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d4fe28949b3be743$export$68d8715fc104d294 = 'write';
var $d4fe28949b3be743$export$70a6e5159acce2e6 = 'afterWrite';
var $d4fe28949b3be743$export$d087d3878fdf71d5 = [
    $d4fe28949b3be743$export$421679a7c3d56e,
    $d4fe28949b3be743$export$aafa59e2e03f2942,
    $d4fe28949b3be743$export$6964f6c886723980,
    $d4fe28949b3be743$export$c65e99957a05207c,
    $d4fe28949b3be743$export$f22da7240b7add18,
    $d4fe28949b3be743$export$bab79516f2d662fe,
    $d4fe28949b3be743$export$8d4d2d70e7d46032,
    $d4fe28949b3be743$export$68d8715fc104d294,
    $d4fe28949b3be743$export$70a6e5159acce2e6
];


function $d275c674dad37c51$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d275c674dad37c51$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d275c674dad37c51$var$order(modifiers); // order based on phase
    return (0, $d4fe28949b3be743$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $84ecd101f0451c57$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4a030c747b32a6c8$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $50feee25326def07$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $50feee25326def07$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $50feee25326def07$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $50feee25326def07$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $50feee25326def07$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(reference) ? (0, $9ffb87717c901c22$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $9ffb87717c901c22$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $9ffb87717c901c22$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $d275c674dad37c51$export$2e2bcd8739ae039)((0, $4a030c747b32a6c8$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$50feee25326def07$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $115d491f91316dac$export$2e2bcd8739ae039)(reference, (0, $903f3a9146d69b74$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $176370100cdcabc3$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $84ecd101f0451c57$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$50feee25326def07$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $50feee25326def07$export$8f7491d57c8f97a9 = /*#__PURE__*/ $50feee25326def07$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $bf0d309c6a59fa65$var$passive = {
    passive: true
};
function $bf0d309c6a59fa65$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $bf0d309c6a59fa65$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $bf0d309c6a59fa65$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $bf0d309c6a59fa65$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $bf0d309c6a59fa65$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $bf0d309c6a59fa65$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $bf0d309c6a59fa65$var$effect,
    data: {}
};



function $4a97ded7040b565f$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $85a510d63b79e143$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $72ad63e74824f68c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $f502ed4faffbd21b$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $85a510d63b79e143$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $d4fe28949b3be743$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $d4fe28949b3be743$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $d4fe28949b3be743$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $d4fe28949b3be743$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $72ad63e74824f68c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $d4fe28949b3be743$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $d4fe28949b3be743$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $0ba1d7084b4fa897$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $f502ed4faffbd21b$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ba1d7084b4fa897$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ba1d7084b4fa897$var$popperOffsets,
    data: {}
};










var $c039ec16f5df24d5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c039ec16f5df24d5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3d396911d7f4ee30$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3d396911d7f4ee30$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c039ec16f5df24d5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4);
    var sideY = (0, $d4fe28949b3be743$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $903f3a9146d69b74$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $309470d3f7110c85$export$2e2bcd8739ae039)(popper);
            if ((0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $d4fe28949b3be743$export$1e95b668f3b82d) || (placement === (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4) || placement === (0, $d4fe28949b3be743$export$79ffe56a765070d2)) && variation === (0, $d4fe28949b3be743$export$bd5df0f255a350f8)) {
            sideY = (0, $d4fe28949b3be743$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4) || (placement === (0, $d4fe28949b3be743$export$1e95b668f3b82d) || placement === (0, $d4fe28949b3be743$export$40e543e69a8b3fbb)) && variation === (0, $d4fe28949b3be743$export$bd5df0f255a350f8)) {
            sideX = (0, $d4fe28949b3be743$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c039ec16f5df24d5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c039ec16f5df24d5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c039ec16f5df24d5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $85a510d63b79e143$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c039ec16f5df24d5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c039ec16f5df24d5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c039ec16f5df24d5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c039ec16f5df24d5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $09defb49252f5ca7$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(element) || !(0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $09defb49252f5ca7$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(element) || !(0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $09defb49252f5ca7$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $09defb49252f5ca7$var$applyStyles,
    effect: $09defb49252f5ca7$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $73fcee30804cfa92$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4),
        (0, $d4fe28949b3be743$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4),
        (0, $d4fe28949b3be743$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $73fcee30804cfa92$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $d4fe28949b3be743$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $73fcee30804cfa92$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $73fcee30804cfa92$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $73fcee30804cfa92$var$offset
};


var $6079ddc51ba4aa82$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $6079ddc51ba4aa82$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $6079ddc51ba4aa82$var$hash[matched];
    });
}



var $b7580317dce52abb$var$hash = {
    start: 'end',
    end: 'start'
};
function $b7580317dce52abb$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b7580317dce52abb$var$hash[matched];
    });
}







function $fe406dab3ca4d7b7$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2ff905f7beff5174$export$2e2bcd8739ae039)(element);
    var html = (0, $309470d3f7110c85$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $1cb94b3ec438f6e4$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $64dc08e0ab50c788$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e97c156aaade7d63$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $309470d3f7110c85$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $589bf04e44fe9a7c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3d396911d7f4ee30$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3d396911d7f4ee30$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $64dc08e0ab50c788$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3d396911d7f4ee30$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $dee36bd95333a498$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $53ecac5ed2bc32f9$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1007f0ba82805a68$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $33644f1c42ed42da$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2f689a5d3f7bdbac$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $33644f1c42ed42da$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $d4fe28949b3be743$export$d7b7311ec04a3e8f) ? (0, $1007f0ba82805a68$export$2e2bcd8739ae039)((0, $fe406dab3ca4d7b7$export$2e2bcd8739ae039)(element, strategy)) : (0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(clippingParent) ? $33644f1c42ed42da$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1007f0ba82805a68$export$2e2bcd8739ae039)((0, $e97c156aaade7d63$export$2e2bcd8739ae039)((0, $309470d3f7110c85$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $33644f1c42ed42da$var$getClippingParents(element) {
    var clippingParents = (0, $9ffb87717c901c22$export$2e2bcd8739ae039)((0, $7fa3ef45193968b0$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $178d7810eb5de6d3$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $53ecac5ed2bc32f9$export$1b3bfaa9684536aa)(element) ? (0, $903f3a9146d69b74$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(clippingParent) && (0, $dee36bd95333a498$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $ee295f51d9d77b47$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $33644f1c42ed42da$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $33644f1c42ed42da$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $33644f1c42ed42da$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3d396911d7f4ee30$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3d396911d7f4ee30$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3d396911d7f4ee30$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3d396911d7f4ee30$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $33644f1c42ed42da$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $cfa7f91d8f75e46d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $98c8d86ee65b08e2$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $cfa7f91d8f75e46d$export$2e2bcd8739ae039)(), paddingObject);
}


function $02fff045850cbb2e$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $4c7614eb6bdf7f0d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $d4fe28949b3be743$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $d4fe28949b3be743$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $d4fe28949b3be743$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $98c8d86ee65b08e2$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $02fff045850cbb2e$export$2e2bcd8739ae039)(padding, (0, $d4fe28949b3be743$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $d4fe28949b3be743$export$ae5ab1c730825774) ? (0, $d4fe28949b3be743$export$ca50aac9f3ba507f) : (0, $d4fe28949b3be743$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $33644f1c42ed42da$export$2e2bcd8739ae039)((0, $53ecac5ed2bc32f9$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $309470d3f7110c85$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2f689a5d3f7bdbac$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $f502ed4faffbd21b$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1007f0ba82805a68$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $d4fe28949b3be743$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $d4fe28949b3be743$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $d4fe28949b3be743$export$79ffe56a765070d2),
                (0, $d4fe28949b3be743$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $d4fe28949b3be743$export$1e95b668f3b82d),
                (0, $d4fe28949b3be743$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $8429a30d321370dd$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $d4fe28949b3be743$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $85a510d63b79e143$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $d4fe28949b3be743$export$368f9a87e87fa4e1) : (0, $d4fe28949b3be743$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $85a510d63b79e143$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $d4fe28949b3be743$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $4c7614eb6bdf7f0d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $4a97ded7040b565f$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b3029b429553ee6e$var$getExpandedFallbackPlacements(placement) {
    if ((0, $4a97ded7040b565f$export$2e2bcd8739ae039)(placement) === (0, $d4fe28949b3be743$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $6079ddc51ba4aa82$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b7580317dce52abb$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b7580317dce52abb$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b3029b429553ee6e$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $6079ddc51ba4aa82$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b3029b429553ee6e$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $4a97ded7040b565f$export$2e2bcd8739ae039)(placement) === (0, $d4fe28949b3be743$export$dfb5619354ba860) ? (0, $8429a30d321370dd$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $85a510d63b79e143$export$2e2bcd8739ae039)(placement) === (0, $d4fe28949b3be743$export$b3571188c770cc5a);
        var isVertical = [
            (0, $d4fe28949b3be743$export$1e95b668f3b82d),
            (0, $d4fe28949b3be743$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $4c7614eb6bdf7f0d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $d4fe28949b3be743$export$79ffe56a765070d2) : (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $d4fe28949b3be743$export$40e543e69a8b3fbb) : (0, $d4fe28949b3be743$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $6079ddc51ba4aa82$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $6079ddc51ba4aa82$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b3029b429553ee6e$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b3029b429553ee6e$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $56d44151933a4b42$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $9a5dd54993433db4$export$f28d906d67a997f3(min, value, max) {
    return (0, $3d396911d7f4ee30$export$8960430cfd85939f)(min, (0, $3d396911d7f4ee30$export$96ec731ed4dcb222)(value, max));
}
function $9a5dd54993433db4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9a5dd54993433db4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $fce2efac5f4131b5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $4c7614eb6bdf7f0d$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $85a510d63b79e143$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $72ad63e74824f68c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $56d44151933a4b42$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $d4fe28949b3be743$export$1e95b668f3b82d) : (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $d4fe28949b3be743$export$40e543e69a8b3fbb) : (0, $d4fe28949b3be743$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $d4fe28949b3be743$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $d4fe28949b3be743$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $176370100cdcabc3$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $cfa7f91d8f75e46d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $9a5dd54993433db4$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $903f3a9146d69b74$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $9a5dd54993433db4$export$f28d906d67a997f3)(tether ? (0, $3d396911d7f4ee30$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3d396911d7f4ee30$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $d4fe28949b3be743$export$1e95b668f3b82d) : (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $d4fe28949b3be743$export$40e543e69a8b3fbb) : (0, $d4fe28949b3be743$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $d4fe28949b3be743$export$1e95b668f3b82d),
            (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $9a5dd54993433db4$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $9a5dd54993433db4$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $fce2efac5f4131b5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $fce2efac5f4131b5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $5d9fc200decbf6fa$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $98c8d86ee65b08e2$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $02fff045850cbb2e$export$2e2bcd8739ae039)(padding, (0, $d4fe28949b3be743$export$aec2ce47c367b8c3)));
};
function $5d9fc200decbf6fa$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $4a97ded7040b565f$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $72ad63e74824f68c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4),
        (0, $d4fe28949b3be743$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $5d9fc200decbf6fa$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $176370100cdcabc3$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $d4fe28949b3be743$export$1e95b668f3b82d) : (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $d4fe28949b3be743$export$40e543e69a8b3fbb) : (0, $d4fe28949b3be743$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $903f3a9146d69b74$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $9a5dd54993433db4$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $5d9fc200decbf6fa$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $dee36bd95333a498$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $5d9fc200decbf6fa$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $5d9fc200decbf6fa$var$arrow,
    effect: $5d9fc200decbf6fa$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $a512a5c3513135c8$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $a512a5c3513135c8$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $d4fe28949b3be743$export$1e95b668f3b82d),
        (0, $d4fe28949b3be743$export$79ffe56a765070d2),
        (0, $d4fe28949b3be743$export$40e543e69a8b3fbb),
        (0, $d4fe28949b3be743$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $a512a5c3513135c8$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $4c7614eb6bdf7f0d$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $4c7614eb6bdf7f0d$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $a512a5c3513135c8$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $a512a5c3513135c8$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $a512a5c3513135c8$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $a512a5c3513135c8$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $a512a5c3513135c8$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $a512a5c3513135c8$var$hide
};




var $b48605ff912629ed$export$d34966752335dd47 = [
    (0, $bf0d309c6a59fa65$export$2e2bcd8739ae039),
    (0, $0ba1d7084b4fa897$export$2e2bcd8739ae039),
    (0, $c039ec16f5df24d5$export$2e2bcd8739ae039),
    (0, $09defb49252f5ca7$export$2e2bcd8739ae039),
    (0, $73fcee30804cfa92$export$2e2bcd8739ae039),
    (0, $b3029b429553ee6e$export$2e2bcd8739ae039),
    (0, $fce2efac5f4131b5$export$2e2bcd8739ae039),
    (0, $5d9fc200decbf6fa$export$2e2bcd8739ae039),
    (0, $a512a5c3513135c8$export$2e2bcd8739ae039)
];
var $b48605ff912629ed$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $50feee25326def07$export$ed5e13716264f202)({
    defaultModifiers: $b48605ff912629ed$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


function $24e10b09052550f3$var$createText(text) {
    const t = document.createElement("span");
    t.innerText = text;
    return t;
}
document.querySelectorAll("a.scroll-link").forEach((elem)=>{
    elem.addEventListener("mouseenter", (_)=>{
        if (elem.hasOwnProperty("data_popper") && elem.data_popper != null) return;
        const tooltip = document.createElement("div");
        tooltip.appendChild($24e10b09052550f3$var$createText("Click to scroll"));
        tooltip.classList.add("tooltip");
        tooltip.setAttribute("data-show", ""); // make popperjs element visible
        const popper = (0, $b48605ff912629ed$export$8f7491d57c8f97a9)(elem, tooltip, {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            2
                        ]
                    }
                }
            ]
        });
        document.body.append(tooltip);
        elem.data_popper = [
            tooltip,
            popper
        ];
        popper.forceUpdate();
    });
    elem.addEventListener("mouseleave", (_)=>{
        if (!elem.hasOwnProperty("data_popper") || elem.data_popper == null) return;
        elem.data_popper[0].remove(); // remove DOM node
        elem.data_popper[1].destroy(); // destroy popperjs object
        elem.data_popper = null;
    });
});


const $80c2a66784c5f84d$export$99a70112ceb8327b = (hexString)=>Uint8Array.from(hexString.match(/.{1,2}/g).map((byte)=>parseInt(byte, 16)));
const $80c2a66784c5f84d$export$49f5757fc3673e03 = (iter)=>{
    const arr = [];
    for (const i of iter)arr.push(i);
    return arr;
};
const $80c2a66784c5f84d$export$9631309e65ab5f32 = (text)=>{
    const line = document.createElement("div");
    let last = document.createElement("span");
    last.classList.add("cw");
    line.append(last);
    const first = last;
    let next_color = false;
    for(let i = 0; i < text.length; i++){
        let c = text[i];
        if (c == "") {
            next_color = true;
            continue;
        }
        if (next_color) {
            if (c == "*") {
                last.innerHTML += "<br>";
                const ll = last;
                last = document.createElement("span");
                last.classList.add(ll.classList[0]);
                line.append(last);
                next_color = false;
                continue;
            }
            const lc = c.toLowerCase();
            let color = lc == c ? "c" + c : `c${lc}d`;
            last = document.createElement("span");
            last.classList.add(color);
            line.append(last);
            next_color = false;
            continue;
        }
        last.innerText += c;
    }
    if (first.innerText == "") first.remove();
    return line;
};


const $13e260f2ffab40a1$var$terminal = document.getElementById("terminal");
const $13e260f2ffab40a1$var$expandBtn = document.getElementById("terminal-expand");
const $13e260f2ffab40a1$var$inputWrap = document.getElementById("terminal-input-wrap");
const $13e260f2ffab40a1$var$input = document.getElementById("terminal-input");
const $13e260f2ffab40a1$var$terminalWindow = document.querySelector(".terminal-window");
function $13e260f2ffab40a1$var$pushLine(text) {
    $13e260f2ffab40a1$var$terminal.append((0, $80c2a66784c5f84d$export$9631309e65ab5f32)(text));
}
function $13e260f2ffab40a1$var$fixTerm() {
    $13e260f2ffab40a1$var$inputWrap.remove();
    $13e260f2ffab40a1$var$terminal.append($13e260f2ffab40a1$var$inputWrap);
    $13e260f2ffab40a1$var$input.value = "";
    $13e260f2ffab40a1$var$input.focus();
    $13e260f2ffab40a1$var$terminal.scrollTop = $13e260f2ffab40a1$var$terminal.scrollHeight;
}
function $13e260f2ffab40a1$var$handleInput(cmd, term, echo) {
    if (echo) $13e260f2ffab40a1$var$pushLine("gguest@absolute-devicew:b~w$ " + cmd);
    const ex = cmd.split(" ")[0];
    if (ex == "clear") $13e260f2ffab40a1$var$terminal.replaceChildren($13e260f2ffab40a1$var$inputWrap);
    else if (ex == "echo") $13e260f2ffab40a1$var$pushLine(cmd.substring(5));
    else if (ex == "fastfetch" || ex == "neofetch") {
        const os = navigator.hasOwnProperty("oscpu") ? navigator.oscpu : navigator.platform;
        const windows = os.toLowerCase().indexOf("win") != -1;
        [
            "tguestw@tabsolute-device",
            "-------------------------",
            `tOSw: ${os}`,
            `tKernelw: ${windows ? "Windows NT" : "Linux 7.0.10"}`,
            `tPackagesw: ${windows ? "\u221E bloatware" : "9 (flatpak), 1634 (pacman). 2354654 updates available"}`,
            `tShellw: ${term}`,
            `tUAw: ${navigator.userAgent}`,
            `q\u{2588}\u{2588}r\u{2588}\u{2588}g\u{2588}\u{2588}o\u{2588}\u{2588}p\u{2588}\u{2588}t\u{2588}\u{2588}w\u{2588}\u{2588}`,
            `Q\u{2588}\u{2588}R\u{2588}\u{2588}G\u{2588}\u{2588}O\u{2588}\u{2588}P\u{2588}\u{2588}T\u{2588}\u{2588}W\u{2588}\u{2588}`
        ].forEach($13e260f2ffab40a1$var$pushLine);
    } else if (ex == "rm") {
        if (cmd.endsWith("/*") || cmd.endsWith("/") || cmd.endsWith("--no-preserve-root")) {
            $13e260f2ffab40a1$var$pushLine("rm: Deleting git@github.com:denisJaved/denisjaved.github.io.git");
            const iframe = document.createElement("iframe");
            iframe.src = "https://doesnotexistplsihope.github.io";
            iframe.style.width = "100vw";
            iframe.style.height = "100vh";
            iframe.style.border = "none";
            document.body.style.padding = "0px";
            document.body.style.margin = "0px";
            document.body.replaceChildren(iframe);
            setTimeout(()=>window.location.reload(), 15000);
        } else $13e260f2ffab40a1$var$pushLine("rm: Only rm -rf / is supported");
    } else if (ex == "sv.cheats") $13e260f2ffab40a1$var$pushLine("rNah bro");
    else if (ex == "sv.ping") {
        let data = {
            index: 0,
            servers: [
                "BRAVO",
                "CHARLIE",
                "DELTA",
                "ECHO",
                "FOXTROT",
                "GOLF",
                "HOTEL",
                "INDIA",
                "JUILETT",
                "KILO",
                "LIMO",
                "MIKE",
                "NOVEMBER",
                "OSCAR",
                "PAPA",
                "QUEBEC",
                "ROMEO",
                "SIERRA",
                "TANGO",
                "VICTOR",
                "WHISKEY",
                "XRAY",
                "YANKEE"
            ]
        };
        $13e260f2ffab40a1$var$pushLine(`Sending packages 'BRAVO'`);
        const inter_id = setInterval(()=>{
            $13e260f2ffab40a1$var$pushLine(`Server '${data.servers[data.index]}' recieved g4/4w packages`);
            data.index++;
            if (data.index < data.servers.length - 1) $13e260f2ffab40a1$var$pushLine(`Sending packages '${data.servers[data.index]}'`);
            else {
                $13e260f2ffab40a1$var$pushLine("Ping 'ALL_SERVERS' finished");
                clearInterval(inter_id);
            }
            $13e260f2ffab40a1$var$fixTerm();
        }, 380);
    } else if (ex == "help" || ex == "man") [
        "Available commands: fastfetch, neofetch, help",
        "sv.ping, sv.cheats, rm, echo, clear, man, reboot",
        "shutdown, sh, fish, bash, djterm"
    ].forEach($13e260f2ffab40a1$var$pushLine);
    else if (ex == "reboot") window.location.reload();
    else if (ex == "shutdown") window.close();
    else if (ex == "sh" || ex == "djterm" || ex == "bash" || ex == "fish") {
        if (cmd.trim() == ex && ex != "djterm") {
            $13e260f2ffab40a1$var$pushLine(`r${ex}: Interactive mode not supported`);
            return;
        }
        $13e260f2ffab40a1$var$handleInput(cmd.substring(ex.length + 1), ex, false);
    } else $13e260f2ffab40a1$var$pushLine("rdjterm: Unknown command: " + ex);
}
const $13e260f2ffab40a1$var$expandTerm = (e)=>{
    const params = new URLSearchParams(window.location.search);
    if ($13e260f2ffab40a1$var$terminalWindow.classList.contains("terminal-window-expanded")) {
        $13e260f2ffab40a1$var$terminalWindow.classList.remove("terminal-window-expanded");
        $13e260f2ffab40a1$var$expandBtn.classList.remove("bi-dash");
        $13e260f2ffab40a1$var$expandBtn.classList.add("bi-plus");
        params.delete("term");
    } else {
        $13e260f2ffab40a1$var$terminalWindow.classList.add("terminal-window-expanded");
        $13e260f2ffab40a1$var$expandBtn.classList.add("bi-dash");
        $13e260f2ffab40a1$var$expandBtn.classList.remove("bi-plus");
        params.set("term", "fullscreen");
    }
    window.history.replaceState({}, "", window.location.origin + window.location.pathname + "?" + params.toString());
    $13e260f2ffab40a1$var$fixTerm();
};
$13e260f2ffab40a1$var$expandBtn.onclick = $13e260f2ffab40a1$var$expandTerm;
$13e260f2ffab40a1$var$input.onkeydown = (e)=>{
    if (e.code == "Enter") {
        $13e260f2ffab40a1$var$handleInput($13e260f2ffab40a1$var$input.value, "djterm", true);
        $13e260f2ffab40a1$var$fixTerm();
    }
};
$13e260f2ffab40a1$var$terminal.onclick = (e)=>$13e260f2ffab40a1$var$input.focus();
(()=>{
    const params = new URLSearchParams(window.location.search);
    if (params.has("term")) $13e260f2ffab40a1$var$expandTerm(null);
    $13e260f2ffab40a1$var$pushLine("Welcome to djterm 1.4.3");
    $13e260f2ffab40a1$var$pushLine('Type command or use "help" for list of commands');
    $13e260f2ffab40a1$var$fixTerm();
})();



// 🯰🯱🯲🯳🯴🯵🯶🯷🯸🯹
const $24b7a9b742a496d7$var$forceMobile = new URLSearchParams(window.location.search).has("tape-mobile");
if ($24b7a9b742a496d7$var$forceMobile) {
    document.getElementById("funtape-force-mobile").style.display = "none";
    document.getElementById("funtape-unforce-mobile").style.display = "block";
}
const $24b7a9b742a496d7$var$mobile = document.body.clientWidth < 1000 || $24b7a9b742a496d7$var$forceMobile;
const $24b7a9b742a496d7$var$tapes = document.querySelectorAll(".funtape");
function $24b7a9b742a496d7$var$dragStart(event) {
    const target = event.target;
    event.dataTransfer?.setData("text/plain", target.id + "," + target.parentElement.id);
    setTimeout(()=>{
        const box = document.createElement("div");
        box.classList.add("funtape-holder-empty", "box");
        const helper = document.createElement("div");
        helper.classList.add("box-helper");
        const e = document.createElement("div");
        e.classList.add("center-flex");
        e.innerHTML = "<p>INSERT TAPE<br /> HERE</p>";
        box.append(helper);
        box.append(e);
        target.parentElement?.append(box);
        target.classList.add("dragged-tape");
    }, 0);
}
function $24b7a9b742a496d7$var$dragStop(event) {
    const target = event.target;
    target.classList.remove("dragged-tape");
    target.parentElement?.querySelector(".funtape-holder-empty")?.remove();
}
function $24b7a9b742a496d7$var$drop(event, holder) {
    const empty = holder.querySelector(".funtape-holder-empty");
    if (empty == null) return; // prevent multiple tapes be in same holder
    const data = event.dataTransfer?.getData("text/plain").split(",");
    const tape = document.getElementById(data[0]);
    tape.remove();
    holder.append(tape);
    empty.remove();
    if (data[1] == "funplayer-holder") $24b7a9b742a496d7$var$deactivateTape(tape);
    if (holder.id == "funplayer-holder") $24b7a9b742a496d7$var$activateTape(tape);
}
function $24b7a9b742a496d7$var$dragOver(event) {
    event.preventDefault();
}
function $24b7a9b742a496d7$var$initHolder(holder) {
    holder.addEventListener("drop", (e)=>$24b7a9b742a496d7$var$drop(e, holder));
    holder.addEventListener("dragover", $24b7a9b742a496d7$var$dragOver);
}
let $24b7a9b742a496d7$var$mobileSelectedTape = null;
function $24b7a9b742a496d7$var$mobileTap(event, target) {
    if ($24b7a9b742a496d7$var$mobileSelectedTape == null) {
        $24b7a9b742a496d7$var$mobileSelectedTape = target.querySelector(".funtape");
        if ($24b7a9b742a496d7$var$mobileSelectedTape != null) target.classList.add("funtape-holder-selected-mobile");
    } else {
        const empty = target.querySelector(".funtape-holder-empty");
        if (empty == null) return;
        empty.remove();
        if ($24b7a9b742a496d7$var$mobileSelectedTape.parentElement?.id == "funplayer-holder") $24b7a9b742a496d7$var$deactivateTape($24b7a9b742a496d7$var$mobileSelectedTape);
        $24b7a9b742a496d7$var$mobileSelectedTape.parentElement?.append(empty);
        $24b7a9b742a496d7$var$mobileSelectedTape.parentElement?.classList.remove("funtape-holder-selected-mobile");
        $24b7a9b742a496d7$var$mobileSelectedTape.remove();
        target.append($24b7a9b742a496d7$var$mobileSelectedTape);
        if (target.id == "funplayer-holder") $24b7a9b742a496d7$var$activateTape($24b7a9b742a496d7$var$mobileSelectedTape);
        $24b7a9b742a496d7$var$mobileSelectedTape = null;
    }
}
function $24b7a9b742a496d7$var$initHolderMobile(holder) {
    holder.onclick = (e)=>$24b7a9b742a496d7$var$mobileTap(e, holder);
}
$24b7a9b742a496d7$var$tapes.forEach($24b7a9b742a496d7$var$mobile ? (tape)=>{
    // Mobile init
    const holder = tape.parentElement;
    $24b7a9b742a496d7$var$initHolderMobile(holder);
} : (tape)=>{
    // Desktop init
    const holder = tape.parentElement;
    tape.setAttribute("draggable", "true");
    tape.addEventListener("dragstart", $24b7a9b742a496d7$var$dragStart);
    tape.addEventListener("dragend", $24b7a9b742a496d7$var$dragStop);
    $24b7a9b742a496d7$var$initHolder(holder);
});
if ($24b7a9b742a496d7$var$mobile) {
    $24b7a9b742a496d7$var$initHolderMobile(document.getElementById("funplayer-holder"));
    $24b7a9b742a496d7$var$initHolderMobile(document.getElementById("funplayer-extra-holder"));
} else {
    $24b7a9b742a496d7$var$initHolder(document.getElementById("funplayer-holder"));
    $24b7a9b742a496d7$var$initHolder(document.getElementById("funplayer-extra-holder"));
}

const $24b7a9b742a496d7$var$tapeScripts = {
    clr_filter: {
        apply: (tape, tp)=>{
            const overlay = $24b7a9b742a496d7$var$createTapeOverlay(tape, tp);
            overlay.innerHTML += `
      <h4>Color Filter</h4>
      Hue: <input class="clr_filter-hue" type="range" min="0" max="360" value="45"><br>
      Saturation: <input class="clr_filter-sat" type="range" min="0" max="10" value="1.5"><br>
      Brightness: <input class="clr_filter-brightness" type="range" min="0" max="600" value="100">
      `;
            function update() {
                const hue = overlay.querySelector(".clr_filter-hue").value;
                const sat = overlay.querySelector(".clr_filter-sat").value;
                const brightness = overlay.querySelector(".clr_filter-brightness").value / 100;
                document.body.style.filter = `hue-rotate(${hue}deg) brightness(${brightness}) saturate(${sat})`;
            }
            [
                ".clr_filter-hue",
                ".clr_filter-sat",
                ".clr_filter-brightness"
            ].forEach((id)=>overlay.querySelector(id).oninput = update);
            document.body.style.filter = "hue-rotate(45deg) brightness(1) saturate(1.5)";
        },
        destroy: (tape, tp)=>{
            $24b7a9b742a496d7$var$destroyTapeOverlay(tape, tp);
            document.body.style.filter = "";
        }
    },
    grayscale: {
        apply: (tape, tp)=>{
            document.body.classList.add("ft1-effect");
        },
        destroy: (tape, tp)=>{
            document.body.classList.remove("ft1-effect");
        }
    },
    secret_tape: {
        apply: (tape, tp)=>{
            setTimeout(tp.auth, 0, tape, tp);
        },
        auth: async (tape, tp)=>{
            const aesjs = await (parcelRequire("caV8q"));
            try {
                const hex = prompt("Decryption key is required to load tape's data");
                if (hex == null) return tp.on_fail(tape, tp);
                const key = (0, $80c2a66784c5f84d$export$99a70112ceb8327b)(hex);
                let aesEcb = new aesjs.ModeOfOperation.ecb(key);
                let decryptedBytes = aesEcb.decrypt((0, $80c2a66784c5f84d$export$99a70112ceb8327b)("d931e9761c792f9d78c269f42b9077b61178bdc10389c64d6479435f1e1f00af"));
                let decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
                if (decryptedText.startsWith("http")) open(decryptedText + "?key=" + hex.toUpperCase());
                else throw new Error("Bad key");
            } catch  {
                tp.on_fail(tape, tp);
            }
        },
        on_fail: (tape, tp)=>{
            const overlay = $24b7a9b742a496d7$var$createTapeOverlay(tape, tp);
            overlay.innerHTML += '<h3 style="color: red;">Decryption key is not valid.</h3>';
        },
        destroy: (tape, tp)=>{
            $24b7a9b742a496d7$var$destroyTapeOverlay(tape, tp);
        }
    }
};
function $24b7a9b742a496d7$var$activateTape(tape) {
    console.log("Activated tape", tape.id);
    const tp = $24b7a9b742a496d7$var$tapeScripts[tape.id];
    tp?.apply(tape, tp);
    const light = document.getElementById("funplayer-tape-light");
    const play = document.getElementById("funplayer-play");
    const nt = document.getElementById("funplayer-nt");
    light.classList.remove("funplayer-light-red");
    light.classList.add("funplayer-light-green");
    play.classList.remove("inactive");
    nt.classList.add("inactive");
}
function $24b7a9b742a496d7$var$deactivateTape(tape) {
    console.log("Deactivated tape", tape.id);
    const tp = $24b7a9b742a496d7$var$tapeScripts[tape.id];
    tp?.destroy(tape, tp);
    const light = document.getElementById("funplayer-tape-light");
    const play = document.getElementById("funplayer-play");
    const nt = document.getElementById("funplayer-nt");
    light.classList.remove("funplayer-light-green");
    light.classList.add("funplayer-light-red");
    play.classList.add("inactive");
    nt.classList.remove("inactive");
}
function $24b7a9b742a496d7$var$createTapeOverlay(tape, tp) {
    const container = document.createElement("div");
    const overlay = document.createElement("div");
    const helper = document.createElement("div");
    container.classList.add("tape-overlay-container");
    overlay.classList.add("box", "tape-overlay", "tape-overlay-" + tape.id);
    helper.classList.add("box-helper");
    document.body.append(container);
    container.append(overlay);
    overlay.append(helper);
    tp.overlay = overlay;
    return overlay;
}
function $24b7a9b742a496d7$var$destroyTapeOverlay(tape, tp) {
    tp.overlay?.parentElement?.remove();
    delete tp.overlay;
}



const $9d72835d05f6b409$var$buttons = (0, $80c2a66784c5f84d$export$49f5757fc3673e03)(document.getElementById("about-btns")?.children);
const $9d72835d05f6b409$var$paginator = document.getElementById("about-paginator");
const $9d72835d05f6b409$var$contents = document.getElementById("about-contents");
for(let i = 0; i < $9d72835d05f6b409$var$buttons.length; i++)$9d72835d05f6b409$var$buttons[i].onclick = ()=>$9d72835d05f6b409$var$onclick(i);
const $9d72835d05f6b409$var$screens = {
    home: {
        text: [
            "Greetings. I am DenisJaved a DevOps engineer and a backend developer.*I also have some frontend experience, but nothing suprising.*I created this website to show some fun stuff and tell about myself.*You can press buttons on the left to navigate this device*and find out more about me if you are intrested."
        ],
        buttons: [
            "this_website",
            "manual"
        ]
    },
    manual: {
        text: [
            "bDENISJAVA MESSAGE DISPLAY (aka DJMD) MANUAL*gDJMD allows reading number of prerecorded messages*in simple 6 button inteface.*In the end of each page (after long dash) each button's action is displayed.*Those actions mean the following:*w*PREVg - go back to previous page of current message.*w*NEXTg - go to next page of current message.*w*SCR-g - scroll action list backwards.*w*SCR+g - scroll action list forwards.*Any other actions mean navigating to different message.*If action is rREDg, it is not available.",
            "bDENISJAVA MESSAGE DISPLAY (aka DJMD) MANUAL*gTop-right corner of the DJMD device displays paginator.*Paginator tells you how much pages are left to this message.*First number is current page. Second number (separated by /) is total amount of pages.*Right arrow means that you are not on last page of this message.*Left arrow means the opposite.*No arrow will be displayed if message contains only one page."
        ],
        buttons: [
            "home"
        ]
    },
    backend: {
        text: [],
        buttons: [
            "home"
        ]
    },
    this_website: {
        text: [
            "Purpose of this website is to be kinda like buiness card, but fun and interactive.*I'm no frontend dev, but I certainly have created dozens of websites.*One of them being this. I though about this website as a challenge.*I wanted to create it without coping other's code or using AI to do so.",
            "bINSPERATION*gI coded all of this website myself with use of some libraries. Them being:*- PopperJS (navbar tooltips)*- aes-js (secret djfun tape encryption)*- boostrap-icons (pack of SVG's)*For DJFUN tapes I took insperation from Gemma Croad's Vintage VHS pack (codepen.io/pen/myrYqZE).*Airbus's Flight Management Display Unit inspired the DJMD (thing you reading this message from)."
        ],
        buttons: [
            "home"
        ]
    }
};
let $9d72835d05f6b409$var$currentState = {
    id: "start",
    page: 0,
    actionScroll: 0,
    actions: [
        null,
        null,
        null,
        null,
        null,
        null
    ]
};
function $9d72835d05f6b409$var$onclick(btn) {
    const action = $9d72835d05f6b409$var$currentState.actions[btn];
    if (action == null || action.startsWith("$")) {
        $9d72835d05f6b409$var$buttons[btn].classList.add("err");
        setTimeout(()=>$9d72835d05f6b409$var$buttons[btn].classList.remove("err"), 500);
        return;
    }
    if (action.startsWith("*")) {
        if (action == "*PREV") $9d72835d05f6b409$var$currentState.page -= 1;
        else if (action == "*NEXT") $9d72835d05f6b409$var$currentState.page += 1;
        else if (action == "*SCR-") $9d72835d05f6b409$var$currentState.actionScroll -= 1;
        else if (action == "*SCR+") $9d72835d05f6b409$var$currentState.actionScroll += 1;
        $9d72835d05f6b409$var$update();
    } else $9d72835d05f6b409$var$setScreen(action);
}
function $9d72835d05f6b409$var$update() {
    const scr = $9d72835d05f6b409$var$screens[$9d72835d05f6b409$var$currentState.id];
    const pages = scr.text.length;
    $9d72835d05f6b409$var$paginator.innerText = `${$9d72835d05f6b409$var$currentState.page + 1} / ${pages} ` + (pages == 1 ? "\u2713" : $9d72835d05f6b409$var$currentState.page + 1 < pages ? "\uD83E\uDC82" : "\uD83E\uDC80");
    let btnOffset = 0;
    if (pages > 1) {
        $9d72835d05f6b409$var$currentState.actions[0] = $9d72835d05f6b409$var$currentState.page == 0 ? "$*PREV" : "*PREV";
        $9d72835d05f6b409$var$currentState.actions[1] = $9d72835d05f6b409$var$currentState.page + 1 >= pages ? "$*NEXT" : "*NEXT";
        btnOffset += 2;
    }
    if (scr.hasOwnProperty("actionScroll")) {
        $9d72835d05f6b409$var$currentState.actions[btnOffset] = $9d72835d05f6b409$var$currentState.actionScroll == 0 ? "$*SCR-" : "*SCR-";
        $9d72835d05f6b409$var$currentState.actions[btnOffset + 1] = $9d72835d05f6b409$var$currentState.actionScroll == scr.buttons.length - 1 ? "$*SCR+" : "*SCR+";
        btnOffset += 2;
    }
    for(let i = 0; i < Math.min(6 - btnOffset, scr.buttons.length - $9d72835d05f6b409$var$currentState.actionScroll); i++){
        const btn = scr.buttons[i + $9d72835d05f6b409$var$currentState.actionScroll];
        $9d72835d05f6b409$var$currentState.actions[i + btnOffset] = btn;
    }
    const lastText = $9d72835d05f6b409$var$currentState.actions.findLastIndex((e)=>e != null) + 1;
    let actionHelp = "";
    for(let i = 0; i < 6; i++){
        const btn = $9d72835d05f6b409$var$currentState.actions[i];
        if (btn == null || btn.startsWith("$")) $9d72835d05f6b409$var$buttons[i].classList.add("inactive");
        else $9d72835d05f6b409$var$buttons[i].classList.remove("inactive");
        if (i < lastText) {
            if (btn?.startsWith("$")) actionHelp += `n${i + 1} r${btn.substring(1)}*`;
            else actionHelp += `n${i + 1} b${btn ?? "nN/A"}*`;
        }
    }
    $9d72835d05f6b409$var$contents.replaceChildren((0, $80c2a66784c5f84d$export$9631309e65ab5f32)(`bPRERECORDED MESSAGE*g${scr.text[$9d72835d05f6b409$var$currentState.page]}*w-------------------------*${actionHelp}`));
}
function $9d72835d05f6b409$var$setScreen(name) {
    $9d72835d05f6b409$var$currentState = {
        id: name,
        page: 0,
        actionScroll: 0,
        actions: [
            null,
            null,
            null,
            null,
            null,
            null
        ]
    };
    $9d72835d05f6b409$var$update();
}
$9d72835d05f6b409$var$setScreen("manual");


 // this is used to make parceljs bundle all scripts together.
 // we can use utilize scope hoisting by this


//# sourceMappingURL=denisjaved.github.io.83d480a4.js.map
